import React from 'react'
import PropTypes from 'prop-types'
import { languagePreference, locale } from '../../../../index'
import firebase from 'firebase/index'

export default class LanguagePicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      languages: undefined
    }
  }

  componentWillMount () {
    this.getSupportedLanguages()
  }

  getSupportedLanguages () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('crescendo').child('configurationByCountry').child(locale).child('supportedLanguages')
    config.on('value', dataSnapshot => {
      this.setState({
        languages: dataSnapshot.val()
      })
    })
  }

  renderLanguageSelect () {
    if (this.state.languages) {
      return <div className='col-xs-12'>
        <select defaultValue={window.localStorage.getItem(languagePreference)} onChange={e => (this.props.handleLanguageChange(e.target.value))} className={'pull-right'}>
          {this.state.languages.map(element => {
            return <option key={element.value} value={element.value} label={element.label}> {element.label} </option>
          })}
        </select>
      </div>
    }
  }

  render () {
    if (this.state.languages) {
      return <div className='col-xs-12' style={{marginTop: '20px'}}>
        {this.renderLanguageSelect()}
      </div>
    } return null
  }
}

LanguagePicker.propTypes = {
  handleLanguageChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Login/LanguagePicker/LanguagePicker.js